/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { Button, Text } from '@/shared/ui';

/**
 * Modal confirmation dialog with a message and confirm/cancel actions.
 *
 * Renders a scrim-backed overlay; clicking the scrim triggers `onCancel`.
 */
export function ConfirmDialog({
  message,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
}: {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel: string;
  cancelLabel: string;
}) {
  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center" onClick={onCancel}>
      <div className="absolute inset-0 bg-[var(--overlay-scrim)]" />
      <div
        className="relative w-full max-w-xs mx-(--space-4) p-(--space-4) rounded-(--radius-lg) border border-[var(--border-subtle)] bg-[var(--surface-primary)] shadow-2xl space-y-(--space-4)"
        onClick={(e) => e.stopPropagation()}
      >
        <Text className="text-sm" style={{ color: 'var(--text-primary)' }}>{message}</Text>
        <div className="flex gap-(--space-2) justify-end">
          <Button
            type="button"
            variant="none"
            disableSize
            onClick={onCancel}
            className="px-(--space-3) py-(--space-1-5) text-xs font-semibold rounded-(--radius-md) border border-[var(--border-subtle)] cursor-pointer hover:bg-[var(--surface-secondary)]"
            style={{ color: 'var(--text-secondary)', background: 'var(--surface-primary)' }}
          >
            {cancelLabel}
          </Button>
          <Button
            type="button"
            variant="none"
            disableSize
            onClick={onConfirm}
            className="px-(--space-3) py-(--space-1-5) text-xs font-bold rounded-(--radius-md) cursor-pointer hover:opacity-90"
            style={{ background: 'var(--status-error-text)', color: 'var(--text-inverse)' }}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
